// Main business phone, shared by the header, footer, contact page and WhatsApp button.
export const PHONE_DISPLAY = "+91 97312 67677";
export const PHONE_TEL = "tel:+919731267677";
export const WHATSAPP_NUMBER = "919731267677";

export const whatsappHref = (message: string) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const DEFAULT_WHATSAPP_MESSAGE = "Hi Lead Workz, I'd like to know more about your services.";

// Google Business Profile (Bangalore). Update the rating/count when they change.
export const GBP_URL = "https://www.google.com/maps?cid=390072023944955566";
export const GBP_RATING = "4.8";
export const GBP_REVIEW_COUNT = 12;
